const theme = {
    name: 'custom-theme',
    tokens: {
      colors: {
        background: {
          primary: { value: '#121212' },
          secondary: { value: '#1E1E1E' },
        },
        font: {
          interactive: { value: '#FFFFFF' },
          primary: { value: '#FFFFFF' },
          secondary: { value: '#00ff00' },
        },
        brand: {
          primary: {
            10: { value: '#00ff00' },
            80: { value: '#00ff00' },
            90: { value: '#00ff00' },
            100: { value: '#00ff00' },
          },
        },
      },
      components: {
        button: {
        borderColor: { value: '#333333' },
          _hover: {
            backgroundColor: { value: 'rgba(0, 255, 0, 0.1)' },
            color: { value: '#00ff00' },
            borderColor: { value: '#00ff00' },
          },
          _focus: {
            backgroundColor: { value: 'rgba(0, 255, 0, 0.1)' },
            boxShadow: { value: '0 0 0 2px #00ff00' },
          },
          _active: {
            backgroundColor: { value: 'rgba(0, 255, 0, 0.2)' },
            borderColor: { value: '#00ff00' },
          },
          primary: {
            backgroundColor: { value: 'transparent' },
            borderColor: { value: '#00ff00' },
            color: { value: '#FFFFFF' },
            borderWidth: { value: '2px' },
            borderRadius: { value: '30px' },
            fontSize: { value: '18px' },
            _hover: {
              backgroundColor: { value: 'rgba(0, 255, 0, 0.1)' },
              color: { value: '#00ff00' },
              boxShadow: { value: '0 0 10px rgba(0, 255, 0, 0.3)' },
            },
          },
        },
        authenticator: {
          router: {
            borderRadius: { value: '0' },
          },
          container: {
            backgroundColor: { value: '{colors.background.primary}' },
          },
          tabItem: {
            color: { value: '{colors.font.primary}' },
            backgroundColor: { value: '{colors.background.primary}' },
            _hover: {
              color: { value: '#00ff00' },
            },
            _active: {
              color: { value: '#00ff00' },
              borderColor: { value: '#00ff00' },
            },
          },
        },
        fieldcontrol: {
          _focus: {
            borderColor: { value: '#00ff00' },
          },
        },
        input: {
          color: { value: '{colors.font.primary}' },
          backgroundColor: { value: '{colors.background.secondary}' },
          borderColor: { value: '#333333' },
          _focus: {
            borderColor: { value: '#00ff00' },
          },
        },
        togglebutton: {
          color: { value: '#00ff00' },
          _hover: {
            color: { value: '#00ff00' },
            backgroundColor: { value: 'rgba(0, 255, 0, 0.1)' },
          },
        },
        field: {
          outer: {
            end: {
              color: { value: '#00ff00' },
              _hover: {
                color: { value: '#00ff00' },
                backgroundColor: { value: 'rgba(0, 255, 0, 0.1)' },
              },
            },
          },
        },
      },
    },
  };
  
  export default theme;